import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-5 container" }
const _hoisted_2 = { class: "header d-flex justify-content-between align-itens-center col mb-3" }
const _hoisted_3 = { class: "float-start m-0 text-neutral_900" }
const _hoisted_4 = { class: "select-ViewMode d-flex w-25 justify-content-around" }
const _hoisted_5 = { for: "viewMode mb-0" }
const _hoisted_6 = { class: "flex align-items-center" }
const _hoisted_7 = {
  for: "batch",
  class: "mb-0 ms-2"
}
const _hoisted_8 = { class: "flex align-items-center" }
const _hoisted_9 = {
  for: "individual",
  class: "mb-0 ms-2"
}
const _hoisted_10 = { class: "page-content shadow-sm" }
const _hoisted_11 = { class: "selectAddType mb-4" }
const _hoisted_12 = { class: "d-flex justify-content-around w-50" }
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = {
  for: "byBatch",
  class: "mb-0 ms-2"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = {
  for: "byIndividual",
  class: "mb-0 ms-2"
}
const _hoisted_17 = { class: "form-group w-100 mb-3" }
const _hoisted_18 = { for: "batchName" }
const _hoisted_19 = { class: "row mb-3" }
const _hoisted_20 = { class: "form-group w-50" }
const _hoisted_21 = { for: "totalCoupoms" }
const _hoisted_22 = { class: "form-group w-50" }
const _hoisted_23 = { for: "qtdCoupom" }
const _hoisted_24 = { class: "form-group w-100 mb-3" }
const _hoisted_25 = { for: "expiration" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_TableViewBatch = _resolveComponent("TableViewBatch")!
  const _component_TableViewIndividual = _resolveComponent("TableViewIndividual")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t("coupons.title")), 1),
        _createVNode(_component_ds_button, {
          class: "float-end",
          type: "primary",
          text: _ctx.$t('coupons.register'),
          leftIcon: "add",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = true))
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("coupons.view")), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_RadioButton, {
            inputId: "batch",
            name: "batch",
            value: "batch",
            modelValue: _ctx.viewType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.viewType) = $event)),
            onChange: _ctx.onChangeView
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("coupons.batch")), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_RadioButton, {
            inputId: "individual",
            name: "individual",
            value: "individual",
            modelValue: _ctx.viewType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.viewType) = $event)),
            onChange: _ctx.onChangeView
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("coupons.single")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.viewType === 'batch')
          ? (_openBlock(), _createBlock(_component_TableViewBatch, {
              key: 0,
              "loader-table": _ctx.loaderTable,
              dataCoupom: _ctx.coupomsLot,
              onDeleteLot: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteLot($event))),
              onDownloadCsv: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadCsvLot($event)))
            }, null, 8, ["loader-table", "dataCoupom"]))
          : (_ctx.viewType === 'individual')
            ? (_openBlock(), _createBlock(_component_TableViewIndividual, {
                key: 1,
                dataCoupom: _ctx.coupoms,
                "loader-table": _ctx.loaderTable,
                onDeleteCoupom: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteCoupom($event)))
              }, null, 8, ["dataCoupom", "loader-table"]))
            : _createCommentVNode("", true),
        _createVNode(_component_Paginator, {
          rows: _ctx.params.size,
          totalRecords: _ctx.params.total,
          onPage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.paginate($event)))
        }, null, 8, ["rows", "totalRecords"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.visible) = $event)),
      modal: "",
      header: "Adicionar Cupom",
      style: { width: '25vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_ds_button, {
          text: _ctx.$t('utils.cancel'),
          type: "secondary",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.visible = false))
        }, null, 8, ["text"]),
        _createVNode(_component_ds_button, {
          disabled: _ctx.dateExpiration ? false : true,
          text: _ctx.$t('utils.save'),
          type: "primary",
          onClick: _ctx.sendCoupom
        }, null, 8, ["disabled", "text", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("coupons.fields.select")) + ":", 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_RadioButton, {
                inputId: "byBatch",
                name: "byBatch",
                value: false,
                modelValue: _ctx.addIndivudual,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addIndivudual) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("coupons.batch")), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_RadioButton, {
                inputId: "byIndividual",
                name: "byIndividual",
                value: true,
                modelValue: _ctx.addIndivudual,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addIndivudual) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("coupons.single")), 1)
            ])
          ])
        ]),
        _createElementVNode("form", null, [
          _withDirectives(_createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("coupons.fields.nameBatch")), 1),
            _createVNode(_component_InputText, {
              id: "batchName",
              inputId: "batchName",
              modelValue: _ctx.coupomLot.name,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.coupomLot.name) = $event)),
              placeholder: "IOSILOTE",
              class: "w-100"
            }, null, 8, ["modelValue"])
          ], 512), [
            [_vShow, !_ctx.addIndivudual]
          ]),
          _createElementVNode("div", _hoisted_19, [
            _withDirectives(_createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("coupons.fields.total")), 1),
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.coupomLot.amountCoupon,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.coupomLot.amountCoupon) = $event)),
                inputId: "totalCoupoms",
                showButtons: "",
                buttonLayout: "horizontal",
                step: 1,
                inputStyle: "width: 2rem",
                decrementButtonClass: "p-button-danger",
                incrementButtonClass: "p-button-success",
                incrementButtonIcon: "pi pi-plus",
                decrementButtonIcon: "pi pi-minus",
                min: 1
              }, null, 8, ["modelValue"])
            ], 512), [
              [_vShow, !_ctx.addIndivudual]
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("coupons.fields.quantCredits")), 1),
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.amountCredit,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.amountCredit) = $event)),
                inputId: "qtdCoupom",
                showButtons: "",
                buttonLayout: "horizontal",
                step: 1,
                inputStyle: "width: 2rem",
                decrementButtonClass: "p-button-danger",
                incrementButtonClass: "p-button-success",
                incrementButtonIcon: "pi pi-plus",
                decrementButtonIcon: "pi pi-minus",
                min: 1
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("coupons.fields.expiration")), 1),
            _createVNode(_component_Calendar, {
              id: "expiration",
              inputId: "expiration",
              modelValue: _ctx.dateExpiration,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dateExpiration) = $event)),
              placeholder: "DD/MM/AAAA",
              "date-format": "dd/mm/yy",
              class: "w-100",
              "min-date": new Date()
            }, null, 8, ["modelValue", "min-date"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}